import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getDocsLegal } from '../../../redux/actions/dataactions';
import {
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Typography,
  CardActions,
  Box,
  Divider,
} from '@mui/material';
import { FaFileInvoice } from 'react-icons/fa';

import DocumentoSubir from './DocumentoSubir';
import DocumentoEliminar from './DocumentoEliminar';
import DocumentoEditar from './DocumentoEditar';

class DocumentacionLegalLista extends Component {
  componentDidMount() {
    this.props.getDocsLegal(this.props.clienteId);
  }

  render() {
    const { doclegales, loadingdata } = this.props.data;
    const { credentials } = this.props.user;
    const isAsistencial = credentials.tipouser === 'Asistencial';

    if (loadingdata) {
      return (
        <Box display="flex" justifyContent="center" mt={5}>
          <CircularProgress size={50} color="primary" />
        </Box>
      );
    }

    if (doclegales.length === 0) {
      return (
        <Card sx={{ p: 4, mt: 4, textAlign: 'center' }}>
          <Typography variant="h6" color="text.secondary">
            Añade un Documento para Empezar
          </Typography>
        </Card>
      );
    }

    return (
      <Grid container spacing={3} sx={{ mt: 1, px: 2 }}>
        {doclegales.map((doc) => (
          <Grid item xs={12} sm={6} md={4} key={doc.docid}>
            <Card
              sx={{
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                borderRadius: 2,
                transition: '0.3s',
                '&:hover': {
                  boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                  transform: 'translateY(-2px)',
                },
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <Box
                    sx={{
                      backgroundColor: doc.url === 'Sin Url' ? '#FF9800' : '#4CAF50',
                      borderRadius: '50%',
                      padding: 1.2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mr: 2,
                    }}
                  >
                    <FaFileInvoice color="#FFFFFF" size={22} />
                  </Box>
                  <Box>
                    <Typography variant="h6" sx={{ color: '#03178C', fontWeight: 600 }}>
                      {doc.tipodoc}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#0468BF' }}>
                      {doc.consecutivo}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ my: 1 }} />

                <Typography variant="body2" sx={{ mt: 1, color: '#03178C', minHeight: 48 }}>
                  {doc.descripcion}
                </Typography>

                <Typography variant="body2" sx={{ mt: 2 }}>
                  {doc.url === 'Sin Url' ? (
                    <Typography variant="body2" color="primary">
                      Sin Documento Adjunto
                    </Typography>
                  ) : (
                    <a
                      href={doc.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#203bd7', textDecoration: 'none' }}
                    >
                      Ver Documento
                    </a>
                  )}
                </Typography>
              </CardContent>

              {!isAsistencial && (
                <CardActions sx={{ justifyContent: 'flex-end', px: 2, pb: 2 }}>
                  <DocumentoSubir docId={doc.docid} clienteId={this.props.clienteId} />
                  <DocumentoEditar doc={doc} clienteId={this.props.clienteId} docId={doc.docid} />
                  <DocumentoEliminar docId={doc.docid} clienteId={this.props.clienteId} />
                </CardActions>
              )}
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }
}

DocumentacionLegalLista.propTypes = {
  getDocsLegal: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
});

export default connect(mapStateToProps, { getDocsLegal })(DocumentacionLegalLista);
